var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootprintList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m428.152 335.717h-102.735c-4.893 0-9.478-2.386-12.284-6.393-34.225-48.844-50.485-141.078-19.098-195.335 16.426-28.396 44.369-42.345 78.661-39.274 111.065 9.94 125.011 156.813 67.537 234.894-2.827 3.841-7.313 6.108-12.081 6.108zm-94.639-30h86.764c39.889-61.933 31.783-173.777-50.256-181.12-22.965-2.057-39.326 5.931-50.019 24.415-21.422 37.034-14.571 110.899 13.511 156.705z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m379.012 510c-45.795 0-79.416-38.947-75.865-82.91l3.593-44.468c.629-7.791 7.136-13.792 14.952-13.792h114.641c7.816 0 14.322 6.002 14.952 13.792l3.594 44.474c3.549 43.941-30.049 82.904-75.867 82.904zm-43.484-111.169-2.479 30.676c-2.237 27.684 18.781 50.493 45.962 50.493 27.145 0 48.203-22.754 45.962-50.487l-2.48-30.682z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m184.589 241.418h-102.736c-4.769 0-9.254-2.268-12.081-6.109-57.506-78.127-43.492-224.956 67.537-234.893 34.297-3.065 62.236 10.878 78.662 39.275 31.387 54.257 15.126 146.491-19.098 195.334-2.807 4.007-7.392 6.393-12.284 6.393zm-94.861-30.001h86.764c28.083-45.805 34.934-119.67 13.511-156.704-10.693-18.485-27.057-26.469-50.019-24.416-81.97 7.337-90.183 119.132-50.256 181.12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m130.993 415.701c-45.818 0-79.415-38.963-75.865-82.904l3.593-44.474c.629-7.791 7.135-13.792 14.952-13.792h114.641c7.816 0 14.322 6.002 14.952 13.792l3.593 44.468c3.551 43.96-30.069 82.91-75.866 82.91zm-43.483-111.17-2.479 30.682c-2.242 27.754 18.837 50.487 45.962 50.487 27.188 0 48.198-22.817 45.962-50.493l-2.479-30.676z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprintList);
export default __webpack_public_path__ + "static/media/FootprintList.f27ad25a.svg";
export { ForwardRef as ReactComponent };